export default "__VITE_ASSET__BvEmWM1Q__"